import {
  fetchSecurityUser,
  fetchSecurityUsers,
  fetchSecurityUsersList,
  fetchUserAccessProfile,
  fetchUserAccessProfiles,
  getSecurityUser,
  resetUserPassword,
  updateSecurityUser,
} from "@actions/index";
import { showSuccessAlert } from "@actions/modals";
import OperatorRegion from "@api/operatorRegion";
import BaseSettings from "@components/systemAdmin/BaseSettings";
import Filters from "@components/systemAdmin/Filters";
import OptionsList from "@components/systemAdmin/OptionsList";
import SelectProfile from "@components/systemAdmin/SelectProfile";
import buildTree from "@helpers/buildTree";
import OptionsModal from "@modals/OptionsModal";
import DataGrid from "@shared/DataGrid";
import React from "react";
import { connect } from "react-redux";
import {
  Accordion,
  Button,
  Grid,
  Header,
  Icon,
  Tab,
} from "semantic-ui-react";
import SystemAccess from "./SystemAccess";

class UserAccounts extends BaseSettings {
  defaultUser = { profileData: [] };
  defaultProfile = { profileId: null, profileData: [] };

  state = {
    activeIndex: 0,
    loading: false,
    dataAccess: 1,
    selectedOperator: null,
    profiles: [],
    users: [],
    usersFullData: {},
    activeUser: this.defaultUser,
    search: "",
    selectedProfile: this.defaultProfile,
    userAccessProfiles: [],
    modalOpen: false,
    modalTitle: "",
    modalOptions: [],
    changed: [],
    profileChanged: false,
    operatorRegions: [],
    orgGrid: { data: [], headerDef: [], rowDef: [] },
    orgTree: [],
    orgTreeSelection: null,
    dataAccessChanged: [],
    orgGridSelections: [],
    operatorCustomerChanged: false,
    selectedRow: null,
    showDataAccess: false,
    expanded: [],
    allExpanded: false,
  };

  componentDidMount() {
    const selectedOperator =
      this.props.operators.length === 1 ? this.props.operators[0].key : null;

    if (selectedOperator) {
      this.fetchAccessProfiles(selectedOperator);
    }

    this.setState({ selectedOperator });
  }

  handleDataAccessChangeValue = (option, value) =>
    this.handleChangeValue(option, value, "dataAccessChanged");

  fetchAccessProfiles = (operator) => {
    fetchUserAccessProfiles(operator, this.state.search).then(
      (userAccessProfiles) => this.setState({ userAccessProfiles }),
    );
  };

  handleOperatorSelect = (event, data) => {
    this.setState(
      {
        selectedOperator: data.value,
        profiles: [],
        activeUser: { ...this.defaultUser },
        selectedProfile: { ...this.defaultProfile },
      },
      () => this.fetchAccessProfiles(data.value),
    );
  };

  handleClick = (user) => {
    this.setState({ expanded: [], allExpanded: false }, () =>
      this.fetchUser(user.id, user.name),
    );
  };

  handleTableRowClick = (row) => {
    const user = this.state.users.find((u) => u.id === row.id);
    if (user) {
      this.handleClick({ id: user.id, name: user.name });
    }
  };

  prepareTableData = () => {
    const { users, activeUser } = this.state;

    const headerDef = [
      { key: "name", text: "Name", sortable: true, lock: false },
      { key: "status", text: "Status", sortable: true, lock: false },
      { key: "userType", text: "User Type", sortable: true, lock: false },
      { key: "accessProfile", text: "Access Profile", sortable: true, lock: false },
      { key: "userName", text: "User Name", sortable: true, lock: false },
      { key: "employeeCode", text: "Employee Code", sortable: true, lock: false },
      { key: "pin", text: "PIN", sortable: true, lock: false },
      { key: "critical", text: "Critical", sortable: true, lock: false },
      { key: "nonCritical", text: "Non-critical", sortable: true, lock: false },
      { key: "remoteSupport", text: "Remote Support", sortable: true, lock: false },
      { key: "eowSummary", text: "EoW Sum.", sortable: true, lock: false },
      { key: "eowNI", text: "EoW NI", sortable: true, lock: false },
      { key: "eowBank", text: "EoW Bank", sortable: true, lock: false },
      { key: "variance", text: "Variance", sortable: true, lock: false },
      { key: "interim", text: "Interim", sortable: true, lock: false },
      { key: "collException", text: "Coll Exception", sortable: true, lock: false },
    ];

    const renderBooleanCell = (value) => {
      const backColour = value
        ? { r: 76, g: 175, b: 80, a: 1 }
        : { r: 244, g: 67, b: 54, a: 1 };
      const foreColour = { r: 255, g: 255, b: 255, a: 1 };

      return {
        type: "cell",
        data: {
          actualValue: value ? "Yes" : "No",
          displayValue: value ? "Yes" : "No",
          backColour,
          foreColour,
          bold: true,
        },
      };
    };

    const data = users.map((user) => {
      
      return {
        id: user.id,
        cellData: [
          {
            type: "cell",
            data: {
              actualValue: user.name || "N/A",
              displayValue: user.name || "N/A",
            },
          },
          {
            type: "cell",
            data: {
              actualValue: user.status || "N/A",
              displayValue: user.status || "N/A",
            },
          },
          {
            type: "cell",
            data: {
              actualValue: user.user_Type || "N/A",
              displayValue: user.user_Type || "N/A",
            },
          },
          {
            type: "cell",
            data: {
              actualValue: user.access_Profile || "N/A",
              displayValue: user.access_Profile || "N/A",
            },
          },
          {
            type: "cell",
            data: {
              actualValue: user.user_Name || "n/a",
              displayValue: user.user_Name || "n/a",
            },
          },
          {
            type: "cell",
            data: {
              actualValue: user.employee_Code || "n/a",
              displayValue: user.employee_Code || "n/a",
            },
          },
          {
            type: "cell",
            data: {
              actualValue: user.pin || "n/a",
              displayValue: user.pin || "n/a",
            },
          },
          renderBooleanCell(user.critical || false),
          renderBooleanCell(user.non_Critical || false),
          renderBooleanCell(user.remote_Support || false),
          renderBooleanCell(user.eoW_Sum || false),
          renderBooleanCell(user.eoW_NI || false),
          renderBooleanCell(user.eoW_Bank || false),
          renderBooleanCell(user.variance || false),
          renderBooleanCell(user.interim || false),
          renderBooleanCell(user.coll_Excep || false),
        ],
      };
    });

    return { headerDef, data, rowDef: data.map(() => ({})) };
  };

  fetchUser = async (id) => {
    const callback = () => this.setState({ loading: false });
    await this.setState({ loading: true });

    fetchSecurityUser(id).then((user) => {
      const activeUser = { ...user, id };
      const usersFullData = {
        ...this.state.usersFullData,
        [id]: user,
      };
      fetchUserAccessProfile(activeUser.userAccessProfile, false).then(
        (selectedProfile) => {
          const showDataAccess = user.optionDisplayDataAccess;
          this.setState(
            {
              activeUser,
              showDataAccess,
              orgTreeSelection: null,
              dataAccessChanged: [],
              orgGridSelections: [],
              operatorCustomerChanged: false,
              selectedProfile,
              usersFullData,
              loading: false,
            },
            () => this.fetchDataAccess(id),
          );
        },
        callback,
      );
    }, callback);
  };

  fetchDataAccess = (id) => {
    OperatorRegion.getUserRegions(
      this.state.selectedOperator,
      id,
      this.state.dataAccess,
    ).then((result) => {
      const operatorRegions =
        result.operatorRegions || this.state.operatorRegions;
      const orgGrid = result.orgGrid || this.state.orgGrid;
      const orgTree = result.orgTree
        ? buildTree(result.orgTree)
        : this.state.orgTree;
      this.setState({
        operatorRegions,
        orgGrid,
        orgTree,
        orgTreeSelection: null,
        orgGridSelections: result.selections,
        dataAccessChanged: [],
        operatorCustomerChanged: false,
      });
    });
  };

  handleSearch = async () => {
    await this.setState({ loading: true });
    const { selectedOperator, search } = this.state;
    await fetchSecurityUsersList(selectedOperator, search).then(
      (usersList) => {
        // The new API returns data directly, no need to fetch individual user data
        this.setState({
          users: usersList,
          usersFullData: {}, // Keep for backward compatibility but not needed
          selectedProfile: this.defaultProfile,
          activeUser: this.defaultUser,
          loading: false,
        });
      },
      () => this.setState({ loading: false }),
    );
    return true;
  };

  handleSearchChange = (event, { value }) => {
    this.setState({ search: value });
  };

  handleProfileSelect = (event, { value }) => {
    fetchUserAccessProfile(value, false).then((selectedProfile) => {
      this.setState({ selectedProfile, profileChanged: true });
    });
  };

  handleOptionChange = (option, value) => {
    const changed = [...this.state.changed].filter(
      (x) => (x.code && x.code !== option.code) || (x.text && x.text !== option.text),
    );
    changed.push({ ...option, value });
    
    const profileData = [...this.state.activeUser.profileData];
    
    const index = profileData.findIndex(
      (item) => 
        (option.code && item.code === option.code) ||
        (option.text && item.text === option.text)
    );
    
    if (index >= 0) {
      profileData[index] = { ...option };
    } else {
      profileData.push({ ...option });
    }
    
    const updatedActiveUser = { 
      ...this.state.activeUser, 
      profileData: [...profileData]
    };
    
    const usersFullData = {
      ...this.state.usersFullData,
      [this.state.activeUser.id]: {
        ...this.state.usersFullData[this.state.activeUser.id],
        profileData: [...profileData],
      },
    };
    
    this.setState(
      { activeUser: updatedActiveUser, usersFullData, changed },
      () => {
        if (option.doRefresh) {
          this.handleSave(false);
        }
      },
    );
  };

  handleSave = (complete = true) => {
    const activeUser = { ...this.state.activeUser };
    updateSecurityUser(
      activeUser.id,
      this.state.selectedOperator,
      this.state.selectedProfile.profileId,
      this.getChanged(),
      complete,
    ).then((response) => {
      if (complete) {
        this.setState({ changed: [], profileChanged: false }, () => {
          this.handleSearch().then(() => {
            this.fetchUser(activeUser.id, activeUser.name);
            this.props.showSuccessAlert(
              `Your changes were saved successfully.`,
            );
          });
        });
      } else {
        const usersFullData = {
          ...this.state.usersFullData,
          [activeUser.id]: {
            ...this.state.usersFullData[activeUser.id],
            profileData: response.profileData,
          },
        };
        this.setState({
          activeUser: {
            ...this.state.activeUser,
            profileData: response.profileData,
          },
          usersFullData,
        });
      }
    });
  };

  handleNewUser = () => {
    getSecurityUser(
      this.state.selectedOperator,
      this.state.selectedProfile.profileId,
    ).then((response) => {
      this.setState({
        modalOptions: response.profileData,
        modalTitle: "New User",
        modalOpen: true,
      });
    });
  };

  handleOptionsReload = async (changes, another, complete) => {
    this.saveNewUser(changes, another, complete);
  };

  saveNewUser = async (details, another, complete = true) => {
    await updateSecurityUser(
      0,
      this.state.selectedOperator,
      this.state.selectedProfile.profileId,
      details,
      complete,
    ).then((response) => {
      if (complete) {
        this.handleSearch().then(() => {
          this.setState({ modalOpen: false }, () => {
            this.fetchUser(response);
            this.props.showSuccessAlert(
              `Your new user was successfully created`,
            );
          });
        });
      } else {
        this.setState({ modalOptions: response.profileData });
      }
    });
  };

  handleResetPassword = () => {
    resetUserPassword(this.state.activeUser.userEmail).then(() =>
      this.props.showSuccessAlert(
        `A reset password email has been sent to ${this.state.activeUser.userEmail}!`,
      ),
    );
  };

  handleProfileClick = (profile) => {
    fetchUserAccessProfile(profile, false).then((selectedProfile) => {
      this.setState({
        selectedProfile,
        activeUser: { profileData: [] },
        profileChanged: false,
      });
    });
  };

  toggleCollapsed = (id) => {
    const expanded = [...this.state.expanded];
    const index = expanded.findIndex((x) => x === id);

    if (index >= 0) {
      expanded.splice(index, 1);
    } else {
      expanded.push(id);
    }

    this.setState({ expanded });
  };

  renderTree = (item) => {
    let css = "clickable text-normal";

    if (this.state.orgTreeSelection === item) {
      css += " treeActive";
    }

    const isExpanded = this.state.expanded.includes(item.id);
    const iconName = isExpanded
      ? "minus square outline"
      : "plus square outline";

    return (
      <div>
        <Accordion.Title index={item.id} className={css}>
          {item.children.length > 0 && (
            <Icon
              name={iconName}
              onClick={() => this.toggleCollapsed(item.id)}
            />
          )}
          <span onClick={() => this.handleNodeClick(item)} className={css}>
            {item.name}
          </span>
        </Accordion.Title>
        {item.children.length > 0 && isExpanded && (
          <Accordion.Content>
            <Accordion.Accordion
              className="ml-3"
              exclusive={false}
              styled={false}
            >
              {item.children.map((x) => this.renderTree(x))}
            </Accordion.Accordion>
          </Accordion.Content>
        )}
      </div>
    );
  };

  handleNodeClick = (orgTreeSelection) => this.setState({ orgTreeSelection });

  addNode = () => {
    let orgGridSelections = [...this.state.orgGridSelections];
    orgGridSelections.push(this.state.orgTreeSelection);

    this.setState({ orgGridSelections, operatorCustomerChanged: true }, () => {
      OperatorRegion.reloadList(
        this.state.selectedOperator,
        this.state.activeUser.id,
        this.state.orgGridSelections,
      ).then((orgGrid) => this.setState({ orgGrid }));
    });
  };

  removeRow = () => {
    let orgGridSelections = [...this.state.orgGridSelections];
    orgGridSelections = orgGridSelections.filter(
      (x) => x.id !== this.state.selectedRow.id,
    );

    this.setState({ orgGridSelections, operatorCustomerChanged: true }, () => {
      OperatorRegion.reloadList(
        this.state.selectedOperator,
        this.state.activeUser.id,
        this.state.orgGridSelections,
      ).then((orgGrid) => this.setState({ orgGrid, selectedRow: null }));
    });
  };

  updateDataAccess = () => {
    const changed =
      this.state.dataAccess === 0
        ? this.getChanged("dataAccessChanged")
        : this.state.orgGridSelections;
    OperatorRegion.updateDataAccess(
      this.state.activeUser.id,
      this.state.dataAccess,
      changed,
    ).then(() => {
      this.fetchDataAccess(this.state.activeUser.id);
      this.props.showSuccessAlert("Data Access updated successfully!");
    });
  };

  render() {
    const optionsPrefix = (
      <Grid.Row key="access_profile">
        <Grid.Column width="8"><b>Access Profile</b></Grid.Column>
        <Grid.Column width="8">
          <SelectProfile
            value={this.state.selectedProfile.profileId}
            profiles={this.state.userAccessProfiles}
            onChange={this.handleProfileSelect}
            disabled={!this.state.selectedOperator}
          />
        </Grid.Column>
      </Grid.Row>
    );

    const panes = [];

    panes.push({
      menuItem: "General Options",
      render: () => {
        return (
          <Tab.Pane className="gs-flex-container-vertical height-100">
            <Grid className="gs-flex-container-vertical height-100">
              <Grid.Row className="flex-stretch">
                <Grid.Column width="16" className="gs-flex-container-vertical">
                  <div className="table-overflow flex-stretch-vertical p-1">
                    <OptionsList
                      labelWidth="8"
                      options={this.state.activeUser.profileData}
                      prefix={optionsPrefix}
                      onChange={this.handleOptionChange}
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width="8">
                  {this.props.logIn.optionallowUserPasswordReset && (
                    <Button
                      icon
                      color="blue"
                      disabled={!this.state.activeUser.id || this.state.loading}
                      loading={this.state.loading}
                      onClick={this.handleResetPassword}
                      size="mini"
                      labelPosition="right"
                    >
                      Reset Password
                      <Icon name="mail" />
                    </Button>
                  )}
                </Grid.Column>
                <Grid.Column width="8" textAlign="right">
                  {this.props.logIn.optionAllowSaveUser && (
                    <Button
                      icon
                      positive
                      disabled={
                        (!this.isValid() && !this.state.profileChanged) ||
                        this.state.loading
                      }
                      loading={this.state.loading}
                      onClick={() => this.handleSave(true)}
                      size="mini"
                      labelPosition="right"
                    >
                      Save Changes
                      <Icon name="save" />
                    </Button>
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Tab.Pane>
        );
      },
    });

    if (this.state.showDataAccess) {
      const css =
        this.state.orgTreeSelection && this.state.orgTreeSelection.type === "OP"
          ? "clickable treeActive"
          : "clickable";

      panes.push({
        menuItem: "Data Access",
        render: () => {
          return (
            <Tab.Pane className="gs-flex-container-vertical height-100">
              <Grid
                className="gs-flex-container-vertical height-100"
                columns="2"
              >
                <Grid.Row className="flex-stretch">
                  <Grid.Column width="6" className="gs-flex-container-vertical">
                    <div className="table-overflow flex-stretch-vertical">
                      <Accordion.Accordion
                        className="m-1"
                        exclusive={false}
                        styled={false}
                      >
                        <Accordion.Title index="all" className={css}>
                          <Icon
                            name={
                              this.state.allExpanded
                                ? "minus square outline"
                                : "plus square outline"
                            }
                            className="clickable"
                            onClick={() =>
                              this.setState({
                                allExpanded: !this.state.allExpanded,
                              })
                            }
                          />
                          <span
                            onClick={() => {
                              this.setState({
                                orgTreeSelection: {
                                  id: 0,
                                  name: "All",
                                  type: "OP",
                                },
                              });
                            }}
                            className="clickable"
                          >
                            All
                          </span>
                        </Accordion.Title>
                        {this.state.allExpanded && (
                          <Accordion.Content>
                            <Accordion.Accordion
                              className="ml-3"
                              exclusive={false}
                              styled={false}
                            >
                              {this.state.orgTree.map((x) =>
                                this.renderTree(x),
                              )}
                            </Accordion.Accordion>
                          </Accordion.Content>
                        )}
                      </Accordion.Accordion>
                    </div>
                  </Grid.Column>
                  <Grid.Column
                    width="10"
                    className="gs-flex-container-vertical"
                  >
                    <DataGrid
                      headings={this.state.orgGrid.headerDef}
                      data={this.state.orgGrid.data}
                      rowDef={this.state.orgGrid.rowDef}
                      onRowClick={(selectedRow) =>
                        this.setState({ selectedRow })
                      }
                      stretched
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="flex-shrink">
                  <Grid.Column width="6">
                    <Button
                      icon
                      positive
                      loading={this.state.loading}
                      disabled={
                        this.state.orgTreeSelection === null ||
                        this.state.orgGridSelections
                          .map((x) => x.id)
                          .includes(this.state.orgTreeSelection.id) ||
                        this.state.loading
                      }
                      onClick={this.addNode}
                      size="mini"
                      labelPosition="right"
                    >
                      Add
                      <Icon name="plus" />
                    </Button>
                  </Grid.Column>
                  <Grid.Column width="10" textAlign="right">
                    <Button
                      icon
                      negative
                      loading={this.state.loading}
                      disabled={!this.state.selectedRow || this.state.loading}
                      onClick={this.removeRow}
                      size="mini"
                      labelPosition="right"
                    >
                      Remove
                      <Icon name="minus" />
                    </Button>
                    <Button
                      icon
                      positive
                      loading={this.state.loading}
                      disabled={
                        !this.state.operatorCustomerChanged ||
                        this.state.loading
                      }
                      onClick={this.updateDataAccess}
                      size="mini"
                      labelPosition="right"
                    >
                      Save Changes
                      <Icon name="save" />
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Tab.Pane>
          );
        },
      });
    }

    panes.push({
      menuItem: "System Access",
      render: () => {
        const { profileName, cms, cmsMobile, siteController } =
          this.state.selectedProfile;
        return (
          <Tab.Pane className="gs-flex-container-vertical height-100">
            <SystemAccess
              profileName={profileName}
              cms={cms}
              cmsMobile={cmsMobile}
              siteController={siteController}
            />
          </Tab.Pane>
        );
      },
    });

    const append = (
      <Button
        icon
        positive
        loading={this.state.loading}
        disabled={!this.state.selectedProfile.profileId || this.state.loading}
        onClick={this.handleNewUser}
        size="mini"
        labelPosition="right"
      >
        New User
        <Icon name="add" />
      </Button>
    );

    return (
      <Grid className="height-100 gs-flex-container-vertical">
        {this.props.operators && (
          <Grid.Row>
            <Grid.Column width="16">
              <Filters
                onOperatorSelect={this.handleOperatorSelect}
                operators={this.props.operators}
                profiles={[]}
                loading={this.state.loading}
                onSearchChange={this.handleSearchChange}
                onSearchClick={this.handleSearch}
                searchDisabled={!this.state.selectedOperator}
                append={this.props.logIn.optionAllowNewUser && append}
              />
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row className="flex-stretch">
          <Grid.Column 
            widescreen={this.state.activeUser.profileData.length > 0 ? 12 : 16}
            largescreen={this.state.activeUser.profileData.length > 0 ? 10 : 16}
            computer={this.state.activeUser.profileData.length > 0 ? 10 : 16}
            tablet={this.state.activeUser.profileData.length > 0 ? 9 : 16}
            mobile={16}
            className="gs-flex-container-vertical"
          >
            <div className="table-overflow flex-stretch-vertical" id="usersList">
              {this.state.users.length > 0 ? (
                <DataGrid
                  headings={this.prepareTableData().headerDef}
                  data={this.prepareTableData().data}
                  rowDef={this.prepareTableData().rowDef}
                  onRowClick={this.handleTableRowClick}
                  activeRow={
                    this.state.activeUser.id
                      ? this.prepareTableData().data.find(
                          (row) => row.id === this.state.activeUser.id,
                        )
                      : null
                  }
                  stretched
                />
              ) : (
                <div className="users-empty-state">
                  {this.state.loading
                    ? "Loading users..."
                    : "No users found. Use search to find users."}
                </div>
              )}
            </div>
          </Grid.Column>
          <OptionsModal
            open={this.state.modalOpen}
            handleReload={this.handleOptionsReload}
            options={this.state.modalOptions}
            title={this.state.modalTitle}
            onClose={() => this.setState({ modalOpen: false })}
            onSave={this.saveNewUser}
          />
          {this.state.activeUser.profileData.length > 0 && (
            <Grid.Column 
              widescreen={4}
              largescreen={6}
              computer={6}
              tablet={7}
              mobile={16}
              className="gs-flex-container-vertical"
            >
              <Header as="h2">
                <Icon name="user" />
                <Header.Content>
                  {this.state.activeUser.displayName}
                  <Header.Subheader>
                    {this.state.selectedProfile.profileName}
                  </Header.Subheader>
                </Header.Content>
              </Header>
              <Tab
                panes={panes}
                activeIndex={this.state.activeIndex}
                onTabChange={(e, { activeIndex }) =>
                  this.setState({ activeIndex })
                }
                className="height-100 gs-flex-container-vertical"
              />
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    operators: state.operators,
    logIn: state.logIn,
  };
};

export default connect(mapStateToProps, { showSuccessAlert })(UserAccounts);
